import * as React from 'react';
import { useInView } from 'react-intersection-observer';

import { theme } from '@notino/react-styleguide';
import { RoutineByCatalogIdQuery } from '@notino/shared/definitions/types';

import { Divider } from '@components/Divider';
import RoutineContent from '@components/Universals/Routine/RoutineContent';
import {
  Container,
  MarginWrapper,
  RoutineWrapper,
  Placeholder,
} from '@components/Universals/Routine/styled';

export const MAX_MEDIUM_BREAKPOINT = `(max-width:${theme.breakpoints.md}rem)`;

export interface IRoutineProps {
  routine: RoutineByCatalogIdQuery['RoutineByCatalogId']['routine'][number];
  showDivider?: boolean;
}
const Routine: React.FC<IRoutineProps> = ({ showDivider = true, routine }) => {
  const [ref, inView] = useInView({ triggerOnce: true });

  return (
    <Container data-testid="routine-container">
      <MarginWrapper>
        {showDivider && <Divider shouldShowOnMobile={false} />}
        <div ref={ref}>
          {inView ? (
            <RoutineWrapper>
              <RoutineContent routine={routine} />
            </RoutineWrapper>
          ) : (
            <Placeholder />
          )}
        </div>
      </MarginWrapper>
    </Container>
  );
};

export default Routine;
